/**
 * BgSetter higher order component
 *
 * This component is used to wrap a component and call the updateAppBackground action
 * when the component mounts to update the app background img and gradient visibility,
 * the color of the background, and the nav background color and text color theme.
 *
 * The component looks in the wrapped component for a backgroundSettings method that
 * must return an object of app and nav background state settings. If the method doesn't
 * exist, this component will just apply sensible defaults (white background and light theme).
 *
 * Each page component/container should be wrapped with this HOC.
 *
 * @module component/BgSetter/BgSetter
 */

import isFunction from 'lodash/isFunction';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { updateAppBackground } from '../../actions/Application';
import { BgSettings } from '../../constants/App';

function BgSetter(ComposedComponent, bgSettings = null) {
  const Wrapper = class extends React.Component {
    static propTypes = {
      bgSetterSettings: PropTypes.object,
      updateAppBackground: PropTypes.func.isRequired,
    };

    componentWillMount() {
      const { bgSetterSettings } = this.props;

      this.props.updateAppBackground(bgSetterSettings || BgSettings.APP_WHITE);
    }

    render() {
      return <ComposedComponent {...this.props} />;
    }
  };

  // eslint-disable-next-line local-rules/always-export-mapstate
  function mapStateToProps(state) {
    return {
      bgSetterSettings: isFunction(bgSettings) ? bgSettings(state) : bgSettings,
    };
  }

  return connect(mapStateToProps, { updateAppBackground })(Wrapper);
}

export default BgSetter;
